/**
 * Uppsägning av lokalhyresavtal för avflyttning (12 kap. JB).
 *
 * Same five-point shape as the villkorsändring sibling; only the meddelande
 * and the erkännande's receipt sentence differ.
 */
import { uppsagningLokalComposition } from './uppsagning_villkorsandring_lokal.js';
export const uppsagningAvflyttningLokalV1 = (values = {}) => uppsagningLokalComposition({
    documentKey: 'uppsagning_avflyttning_lokal',
    title: 'Uppsägning av lokalhyresavtal för avflyttning',
    formNumber: 'Formulär R-25',
    meddelandeRef: 'uppsagning_avflyttning_lokal.meddelande@v1',
    receipt: 'En med denna likalydande handling har jag denna dag tagit emot.',
    meta: {
        shortTitle: 'Uppsägning avflyttning (lokal)',
        statute: '12 kap. 57–58 §§ jordabalken',
        preamble: 'Hyresvärdens uppsägning av lokalhyresavtalet för avflyttning enligt 12 kap. jordabalken.',
        description: 'Hyresvärdens uppsägning av ett lokalhyresavtal för avflyttning (12 kap. JB). Använd när hyresvärden vill att lokalhyresgästen flyttar och vägrar förlängning på en besittningsbrytande grund (12 kap. 57 §).\n\n' +
            'Vem undertecknar: hyresvärden (uppsägningen) och hyresgästen (erkännande om mottagande). Skickas via Scrive.\n\n' +
            'OBS! Uppsägningen måste vara delgiven hyresgästen senast sista dagen för uppsägning — säkerställ att delgivning kan styrkas. Hyresgästen har indirekt besittningsskydd och måste hänskjuta tvisten till hyresnämnden för medling inom två månader, annars förfaller rätten till ersättning (12 kap. 58 § JB).\n\n' +
            'Kopplad mall — skapas under det lokalhyresavtal som sägs upp. Parter, lokal och avtalsnummer förförifylls från lokalavtalet (även om det är ett importerat avtal).',
    },
}, values);
//# sourceMappingURL=uppsagning_avflyttning_lokal.js.map